import { RouteObject, Navigate } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/admin',
    element: <Admin />
  },
  {
    path: '/home',
    element: <Navigate to="/" replace />
  },
  {
    path: '/wishlist',
    element: <Navigate to="/" replace />
  },
  {
    path: '/christmas-wishlist',
    element: <Navigate to="/" replace />
  },
  {
    path: '/valeria-wishlist',
    element: <Navigate to="/" replace />
  },
  // Redirect any old version paths to current version
  {
    path: '/v1/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v2/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v3/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v4/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v5/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v6/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v7/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v8/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v9/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v10/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/v11/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/version/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/old/*',
    element: <Navigate to="/" replace />
  },
  {
    path: '/previous/*',
    element: <Navigate to="/" replace />
  },
  // Catch all other routes
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
